import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";

import { IconLight } from "../../components";
import { REPORT_ACTIONS } from "../_utils/constants";

const buttonProps = {
  // size: "small",
  // type: "primary",
  //ghost: true,
  shape: "circle",
  style: {
    marginBottom: "8px",
    border: 0,
    background: "transparent"
  }
};

const CoreReportActionBarLeft = ({ onAction }) => {
  const onButtonClick = action => () => {
    onAction(action);
  };
  return (
    <div>
      <Button
        {...buttonProps}
        title={"Add new report"}
        onClick={onButtonClick(REPORT_ACTIONS.ADD)}
      >
        <IconLight icon={"plus"} />
      </Button>
      <Button
        {...buttonProps}
        title={"Edit report properties"}
        onClick={onButtonClick(REPORT_ACTIONS.OPEN_REPORT_PROPS)}
      >
        <IconLight icon={"pencil-alt"} />
      </Button>
      <Button
        {...buttonProps}
        title={"Duplicate report"}
        onClick={onButtonClick(REPORT_ACTIONS.DUPLICATE)}
      >
        <IconLight icon={"clone"} />
      </Button>
      <Button
        {...buttonProps}
        title={"Move report up"}
        onClick={onButtonClick(REPORT_ACTIONS.MOVE_UP)}
      >
        <IconLight icon={"arrow-up"} />
      </Button>
      <Button
        {...buttonProps}
        title={"Move report down"}
        onClick={onButtonClick(REPORT_ACTIONS.MOVE_DOWN)}
      >
        <IconLight icon={"arrow-down"} />
      </Button>

      <Button
        {...buttonProps}
        title={"Close report"}
        onClick={onButtonClick(REPORT_ACTIONS.CLOSE)}
      >
        <IconLight icon={"trash-alt"} />
      </Button>
    </div>
  );
};

CoreReportActionBarLeft.propTypes = {
  onAction: PropTypes.func.isRequired
};

export default CoreReportActionBarLeft;



// WEBPACK FOOTER //
// ./src/views/core/core_report_action_bar_left/CoreReportActionBarLeft.jsx